// extracted by mini-css-extract-plugin
module.exports = {"actions":"messageHistory_actions__3M6Oj","search":"messageHistory_search__3sg2h","marginBottom":"messageHistory_marginBottom__mMPt0"};